import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from '@/App';
import { configureAmplify } from '@/lib/auth/configureAmplify';
import { AuthProvider } from '@/lib/auth/AuthProvider';
import '@/styles/global.css';

configureAmplify();

// Mock user opcional (dev local sem backend). Ativado via VITE_DEV_MOCK_USER=true.
const useMock = import.meta.env.VITE_DEV_MOCK_USER === 'true';
const mockUser = useMock
  ? {
      username: 'cayo.dev',
      email: 'cayo@weaura.tech',
      name: 'Cayo (mock)',
      groups: ['approvers', 'auditors', 'admins'],
    }
  : undefined;

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root não encontrado em index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider mockUser={mockUser}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
